var api = require('api')

var alertErrorHandler = function (err) {
  console.log(err)
  alert('Error message: ' + err.message)
}

module.exports = function (lang, next) {
  console.log(lang)
  var data = {}
    // TODO set lang code dynamically, from either header or url
  return api.Label.get({
    lang: lang,
    type: 'all'
  }).then(function (response) {
    data['labels'] = response.data
    return api.Lookup.get()
  }, alertErrorHandler).then(function (response) {
    data['lookups'] = response.data
    return api.AppConfig.get()
  }, alertErrorHandler).then(function (response) {
    data['appConfig'] = response.data
    return data
  }, alertErrorHandler).then(next, alertErrorHandler)
}



// WEBPACK FOOTER //
// ./src/api/init.js